<template>
  <v-form v-model="valid">
    <v-row class="mb-0">
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-text-field code="prenom" v-model="recherche.prenom" optional></opq-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-text-field code="nom" v-model="recherche.nom" optional></opq-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-text-field code="ville" v-model="recherche.ville" optional></opq-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue code="region" v-model="recherche.region" optional class="mr-3"></opq-catalogue>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue multiple code="langue" v-model="recherche.langues" optional class="mr-3"></opq-catalogue>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue code="sexe" v-model="recherche.sexe" optional></opq-catalogue>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-case code="offre-supervision" v-model="recherche.offreSupervision" optional width="300"></opq-case>
      </v-col>

      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue multiple code="clientele" :filter="filterCatalogue" v-model="recherche.clienteles" optional class="mr-3"></opq-catalogue>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue
          multiple
          code="orientation-theorique"
          v-model="recherche.orientationsTheoriques"
          optional
          :error="plusQue2Orientations"
          :error-messages="plusQue2Orientations ? $t('formulaires.deuxChoixMaximum') : ''"
        ></opq-catalogue>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue
          multiple
          code="problematique"
          :filter="filterCatalogue"
          v-model="recherche.problematiques"
          optional
          order-by="text"
        ></opq-catalogue>
      </v-col>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-catalogue multiple code="service-offert" :filter="filterCatalogue" v-model="recherche.servicesOfferts" optional></opq-catalogue>
      </v-col>
      <template v-if="service == 'PS'">
        <v-col cols="12" sm="6" md="12" class="py-0">
          <opq-catalogue
            multiple
            code="secteur-de-pratique"
            v-model="recherche.secteursDePratique"
            optional
            :error="plusQue2Secteurs"
            :error-messages="plusQue2Secteurs ? $t('formulaires.deuxChoixMaximum') : ''"
          ></opq-catalogue>
        </v-col>
        <v-col cols="12" sm="6" md="12" class="py-0">
          <opq-case code="mediateur-accredite" v-model="recherche.mediateurAccredite" optional width="300"></opq-case>
        </v-col>
        <v-col cols="12" sm="6" md="12" class="py-0">
          <opq-case code="attestation-neuropsy" v-model="recherche.detenteurAttestationNeuropsy" optional width="300"></opq-case>
        </v-col>
      </template>
      <v-col cols="12" sm="6" md="12" class="py-0">
        <opq-case code="telepratique" v-model="recherche.telepratique" optional width="300"></opq-case>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      valid: false
    }
  },
  props: {
    recherche: {
      type: Object
    },
    service: { type: String }
  },
  computed: {
    plusQue2Secteurs() {
      return this.recherche.secteursDePratique.length > 2
    },
    plusQue2Orientations() {
      return this.recherche.orientationsTheoriques.length > 2
    }
  },
  methods: {
    filterCatalogue(fd) {
      if (this.service == "PT") {
        return fd.code.includes("PST")
      }
      return true
    }
  }
}
</script>

<style>
</style>